<template>
  <div class="categories-wrapper">
    <h2 class="form-title">Choose extra modules</h2>
    <new-module
      :selected="form.modules.workshops"
      title="Workshops"
      text="Enable this module to empower your attendees by registering to multiple workshops hosted at your event."
      @click="toggleModule('workshops')"
    />
    <new-module
      v-if="!isSportOrganization()"
      :selected="form.modules.categoriesAndZones"
      title="Categories & zones"
      text="If you're managing a major event, you can enable accreditation categories and zones to control venue access privileges."
      @click="toggleModule('categoriesAndZones')"
    />
    <new-module
      v-if="!isSportOrganization()"
      :selected="form.modules.mobileApp"
      title="Mobile app"
      text="By enabling mobile app, your attendees can easily access info about your event and find new connections at site."
      @click="toggleModule('mobileApp')"
    />
    <new-module
      :selected="form.modules.ticketing"
      title="Tickets"
      text="Enabling tickets gives you the opportunity to sell tickets to your attendees."
      @click="toggleModule('ticketing')"
    />
    <new-module
      v-if="form.modules.ticketing && !isSportOrganization()"
      :selected="form.modules.floorPlan"
      title="Floor plan"
      text="Enabling the floor plan allows you to have multiple sections in your venue for multiple ticket types."
      @click="toggleModule('floorPlan')"
    />
    <div class="buttons-wrapper">
      <main-button text="CANCEL" flat depressed @click="goBack()" />
      <div class="buttons">
        <main-button flat outline @click="() => this.$emit('back')">
          <v-icon class="arrow-back">arrow_back</v-icon>
          <span>back</span>
        </main-button>
        <main-button text="CREATE EVENT" :disabled="submittingForm" @click="() => this.$emit('submit')" />
      </div>
    </div>
  </div>
</template>

<script>
import newModule from './new-module.vue'

export default {
  name: 'event-extra-modules',
  components: {
    newModule,
  },
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => {},
    },
    submittingForm: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: this.initialValues,
    }
  },
  methods: {
    toggleModule(name) {
      const modules = this.form.modules
      const disableTicketAndFloorPlan = ['categoriesAndZones', 'workshops', 'mobileApp'].includes(
        name,
      )
      const toggleTicket = name === 'ticketing'
      this.form.modules = {
        ...modules,
        workshops:
          name === 'mobileApp' && !modules['mobileApp']
            ? true
            : !toggleTicket && modules['workshops'],
        mobileApp:
          (name === 'workshops' && modules['workshops']) || toggleTicket
            ? false
            : modules['mobileApp'],
        ticketing: disableTicketAndFloorPlan ? false : modules.ticketing,
        categoriesAndZones: toggleTicket ? false : modules.categoriesAndZones,
        floorPlan:
          modules.ticketing === false || disableTicketAndFloorPlan ? false : modules.floorPlan,
        [name]: !modules[name],
      }
    },
    isSportOrganization() {
      return this.$route.path.includes('/sport-organizations/')
    },
  },
}
</script>

<style scoped>
.categories-wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 0.75rem;
}
@media screen and (max-width: 700px) {
  .categories-wrapper {
    display: flex;
    flex-direction: column;
  }
}
.buttons-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.title {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1.125rem;
  color: #ff4c00;
}
.description {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  color: #979797;
}
.inputs {
  display: flex;
  flex-wrap: wrap;
  column-gap: 1rem;
  row-gap: 0.5rem;
}
.text-field {
  flex-basis: 45%;
}
.vat-text {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1.125rem;
  margin-top: 1.5rem;
  color: #333333;
}
.radio-item {
  display: inline-block;
  position: relative;
  padding: 0 0.375rem;
  margin: 0.625rem 0 0;
}

.radio-item input[type='radio'] {
  display: none;
}

.radio-item label {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1.125rem;
  color: #979797;
}

.radio-item label:before {
  content: ' ';
  display: inline-block;
  position: relative;
  top: 0.313rem;
  margin: 0 0.313rem 0 0;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 0.688rem;
  border: 0.125rem solid #666666;
  background-color: transparent;
}

.radio-item input[type='radio']:checked + label:after {
  border-radius: 0.688rem;
  width: 0.75rem;
  height: 0.75rem;
  position: absolute;
  top: 0.563rem;
  left: 0.625rem;
  content: ' ';
  display: block;
  background: #0277bd;
}
@media screen and (max-width: 444px) {
  .buttons-wrapper {
    flex-direction: column-reverse;
  }
  .buttons {
    display: flex;
    flex-direction: column-reverse;
  }
}
@media screen and (max-width: 600px) {
  .inputs {
    display: flex;
    flex-direction: column;
    row-gap: 0.75rem;
  }
}
.arrow-back {
  margin-right: 0.625rem;
}
.form-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  margin-bottom: 1rem;
  color: #ff4c00;
}
.finance-info {
  padding: 0 3.5rem 2rem;
}
</style>
